import { render, staticRenderFns } from "./InvoiceGuard.vue?vue&type=template&id=82156540&lang=pug"
import script from "./InvoiceGuard.vue?vue&type=script&lang=js"
export * from "./InvoiceGuard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports